module.exports = "/images/vendor/flag-icon-css/flags/4x3/jo.svg?9e2f2b3ac5784152799cde822b9ebc29";